// We need jQuery
var $ = window.jQuery;
import select2 from '../shared/select2';

export default {
  loaded() {
    select2()

    $('#dummy-email').on('click', function() {
      const email = + new Date() + '@user.workingtravelgroup.com';
      $('form #email').val(email)
    })
  }
}
